PluginButtonsView = require 'views/plugin/plugin-buttons-view'
PluginHeaderButtonView = require 'views/plugin/plugin-header-button-view'

module.exports = class PluginHeaderButtonsView extends PluginButtonsView
  tagName: 'span'
  className: 'board-header-plugin-btns'
  buttonView: PluginHeaderButtonView
  runnerOptions: ->
    command: 'board-buttons'
    timeout: 10000
    board: @model



// WEBPACK FOOTER //
// ./app/scripts/views/plugin/plugin-header-buttons-view.coffee